__turbopack_context__.v({
  "button": "Button-module__wti9sq__button",
  "danger": "Button-module__wti9sq__danger",
  "fullWidth": "Button-module__wti9sq__fullWidth",
  "ghost": "Button-module__wti9sq__ghost",
  "lg": "Button-module__wti9sq__lg",
  "md": "Button-module__wti9sq__md",
  "primary": "Button-module__wti9sq__primary",
  "secondary": "Button-module__wti9sq__secondary",
  "sm": "Button-module__wti9sq__sm",
  "success": "Button-module__wti9sq__success",
  "withIcon": "Button-module__wti9sq__withIcon",
});
